import { observable, action } from 'mobx';
import { toast } from 'react-toastify';

import { fetchEmployees } from '../api/employees';

export default class EmployeeStore {
  @observable fetchState = 'pending'
  @observable employees = []

  @action
  fetchEmployees(date = false) {
    this.employees = [];
    this.fetchState = 'pending';

    return fetchEmployees(date)
      .then(this.fetchEmployeesSuccess)
      .catch(this.fetchEmployeesError);
  }

  @action.bound
  fetchEmployeesSuccess(res) {
    this.employees = Array.prototype.slice.call(res);
    this.fetchState = 'success';
  }

  @action.bound
  fetchEmployeesError() {
    this.employees = [];
    this.fetchState = 'error';

    toast.error('Fout bij het ophalen van de medewerkers');
  }
}



// WEBPACK FOOTER //
// ./src/store/employeeStore.js